import api from './api';

const base = (roomId) => `/api/rooms/${roomId}/leagues`;

export const getLeagues = async (roomId) => {
  const response = await api.get(base(roomId));
  return response.data;
};

export const getLeague = async (roomId, leagueId) => {
  const response = await api.get(`${base(roomId)}/${leagueId}`);
  return response.data;
};

export const createLeague = async (roomId, data) => {
  const response = await api.post(base(roomId), data);
  return response.data;
};

export const updateLeague = async (roomId, leagueId, data) => {
  const response = await api.put(`${base(roomId)}/${leagueId}`, data);
  return response.data;
};

export const deleteLeague = async (roomId, leagueId) => {
  await api.delete(`${base(roomId)}/${leagueId}`);
};
